
import { Component, Mixins, Emit } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import store from '@/store';
import LatestMenu from '@/mixins/LatestMenu';
import { getBeginnerNaviUrl, showBeginnerNaviButton } from '@/lib/functions';

@Component
export default class GlobalMenu extends Mixins(LatestMenu) {
  private name = 'GlobalMenu';
  
  @Emit()
  private openModalSearchNavi(): void {
    store.commit('searchmodal/open', 'ModalSearchnavi');
  }
  private get beginnerNaviUrl(): string {
    return getBeginnerNaviUrl(store.getters["auth/group"]);
  }
  private get showBeginnerNaviButton(): boolean {
    return showBeginnerNaviButton(store.getters["auth/group"]);
  }
}
